class NailSelectionComponent extends HTMLElement {
  constructor() {
    super();
    this.isMemberMode = true; // Default to member mode
    this.memberDiscount = 0.22; // 22% discount
    this.globalQuantity = 1; // Track global quantity
    this.init();
  }

  init() {
    this.bindEvents();
    this.bindMemberToggle();
    this.initMemberState();
  }

  initMemberState() {
    const savedState = sessionStorage.getItem('booClubWidgetSelected');
    this.isMemberMode = savedState !== '0';
    this.updatePriceDisplay();
  }

  bindMemberToggle() {
    document.addEventListener('member:toggle', (event) => {
      this.isMemberMode = event.detail.isSelected;
      this.memberDiscount = event.detail.discount || 0.22;
      this.updatePriceDisplay();
    });
  }

  updatePriceDisplay() {
    const nailSelection = this.querySelector('.nail-selection');
    if (nailSelection) {
      nailSelection.dataset.memberMode = this.isMemberMode.toString();
    }

    this.updateDrawerPriceDisplay();
  }

  updateDrawerPriceDisplay() {
    const drawer = document.querySelector('nail-selection-drawer');
    if (!drawer) return;

    const drawerContent = drawer.querySelector('.nail-selection__drawer');
    if (drawerContent) {
      drawerContent.dataset.memberMode = this.isMemberMode.toString();
    }
  }

  bindEvents() {
    const drawerTriggers = this.querySelectorAll('[data-drawer-trigger]');
    drawerTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => this.openDrawer());
    });

    this.bindCardClicks();
    this.bindGlobalAddSection();
    this.bindInfoIconClicks();
  }

  bindInfoIconClicks() {
    const infoButtons = this.querySelectorAll('[data-member-info-trigger]');
    infoButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        
        this.showMemberPopup();
      });
    });
  }

  showMemberPopup() {
    const dialog = document.querySelector('.exm_dialog-collection');
    if (dialog) {
      document.querySelector('.transition-body')?.classList.remove('transition-body');
      dialog.style.display = '';
      setTimeout(() => {
        dialog.classList.add('exm_clr-is-open');
      }, 10);
    }
  }

  bindGlobalAddSection() {
    const addSection = this.querySelector('.nail-selection__add-section');
    if (!addSection) return;

    const decreaseBtn = addSection.querySelector('[data-action="decrease"]');
    const increaseBtn = addSection.querySelector('[data-action="increase"]');
    const quantityDisplay = addSection.querySelector('.nail-selection__global-qty-value');
    const addToCartBtn = addSection.querySelector('.nail-selection__add-to-cart-btn');

    // Quantity controls
    if (decreaseBtn && quantityDisplay) {
      decreaseBtn.addEventListener('click', () => {
        if (this.globalQuantity > 1) {
          this.globalQuantity--;
          quantityDisplay.textContent = this.globalQuantity;
        }
      });
    }

    if (increaseBtn && quantityDisplay) {
      increaseBtn.addEventListener('click', () => {
        this.globalQuantity++;
        quantityDisplay.textContent = this.globalQuantity;
      });
    }

    // Add to Cart button
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', () => {
        const selectedCard = this.querySelector('.nail-selection__card.selected');
        if (!selectedCard) {
          alert('Please select a shade first');
          return;
        }

        const isAvailable = selectedCard.getAttribute('data-available') !== 'false';
        if (!isAvailable) {
          alert('This shade is currently sold out');
          return;
        }

        const productId = selectedCard.getAttribute('data-product-id');
        this.addToCart(productId);
        
        // Reset quantity after adding
        this.globalQuantity = 1;
        if (quantityDisplay) {
          quantityDisplay.textContent = '1';
        }
      });
    }

    // Update button state based on selected card
    this.updateAddToCartButtonState();
  }

  updateAddToCartButtonState() {
    const addToCartBtn = this.querySelector('.nail-selection__add-to-cart-btn');
    if (!addToCartBtn) return;

    const selectedCard = this.querySelector('.nail-selection__card.selected');
    if (selectedCard) {
      const isAvailable = selectedCard.getAttribute('data-available') !== 'false';
      addToCartBtn.disabled = !isAvailable;
      addToCartBtn.textContent = isAvailable ? 'Add To Cart' : 'Sold Out';
    }
  }

  bindCardClicks() {
    const cards = this.querySelectorAll('.nail-selection__card');
    cards.forEach(card => {
      card.addEventListener('click', (e) => {
        if (e.target.closest('button')) return;
        
        const productTitle = card.getAttribute('data-product-title');
        const productMedia = card.getAttribute('data-product-media');
        const productId = card.getAttribute('data-product-id');
        
        this.updateSelectedState(card);
        this.updateShadeTitle(productTitle);
        this.updateMainProductImages(productMedia, productId);
        this.updateAddToCartButtonState();
      });
    });
  }

  updateShadeTitle(productTitle) {
    const shadeTitle = document.getElementById('dynamic-shade-title');
    if (shadeTitle && productTitle) {
      shadeTitle.textContent = 'SHADE: ' + productTitle.toUpperCase();
    }
  }

  updateMainProductImages(productMedia, productId) {
    requestAnimationFrame(() => {
      const selectedCard = this.querySelector('.nail-selection__card.selected');
      if (!selectedCard) return;

      const productTitle = selectedCard.getAttribute('data-product-title');
      const productMediaData = this.getProductMedia(selectedCard);

      if (!productMediaData || productMediaData.length === 0) return;

      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) return;

      const mediaItems = mediaGallery.querySelectorAll('.product__media-item');
      const thumbnailItems = mediaGallery.querySelectorAll('.thumbnail-list__item');

      mediaItems.forEach((mediaItem, index) => {
        const img = mediaItem.querySelector('img');
        if (img && productMediaData[index]) {
          const mediaData = productMediaData[index];
          
          img.src = mediaData.url;
          img.alt = mediaData.alt;
          
          const newSrcset = this.generateSrcset(mediaData.url);
          img.srcset = newSrcset;
        }
      });

      thumbnailItems.forEach((thumbnailItem, index) => {
        const img = thumbnailItem.querySelector('img');
        if (img && productMediaData[index]) {
          const mediaData = productMediaData[index];
          
          img.src = mediaData.url.replace('width=600', 'width=416');
          img.alt = mediaData.alt;
          
          const thumbnailSrcset = this.generateThumbnailSrcset(mediaData.url);
          img.srcset = thumbnailSrcset;
        }
      });
    });
  }

  getProductMedia(card) {
    const scriptTag = card.querySelector('script[data-product-media]');
    if (scriptTag) {
      try {
        return JSON.parse(scriptTag.textContent);
      } catch (e) {
        console.error('Error parsing product media:', e);
        return [];
      }
    }
    return [];
  }

  generateSrcset(baseUrl) {
    const sizes = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946];
    return sizes.map(size => {
      const url = baseUrl.replace('width=600', `width=${size}`);
      return `${url} ${size}w`;
    }).join(', ');
  }

  generateThumbnailSrcset(baseUrl) {
    const sizes = [54, 74, 104, 162, 208, 324, 416];
    return sizes.map(size => {
      const url = baseUrl.replace('width=600', `width=${size}`);
      return `${url} ${size}w`;
    }).join(', ');
  }

  updateSelectedState(selectedCard) {
    const allCards = this.querySelectorAll('.nail-selection__card');
    allCards.forEach(card => {
      card.classList.remove('selected');
    });

    selectedCard.classList.add('selected');
  }

  swapProduct(productId, productTitle, productHandle, productMedia, drawerCard) {
    const mainComponent = document.querySelector('nail-selection-component');
    if (!mainComponent) return;
    
    const grid = mainComponent.querySelector('#nail-selection-grid');
    if (!grid) return;
    
    const cards = grid.querySelectorAll('.nail-selection__card');
    
    // Find the last VISIBLE card (important for mobile where 10th card is hidden)
    let lastCard = null;
    for (let i = cards.length - 1; i >= 0; i--) {
      const card = cards[i];
      const style = window.getComputedStyle(card);
      if (style.display !== 'none') {
        lastCard = card;
        break;
      }
    }
    
    if (!lastCard) return;

    const drawerMediaData = this.getProductMedia(drawerCard);
    const drawerVariants = this.getProductVariants(drawerCard);
    
    const isAvailable = drawerCard.getAttribute('data-available') !== 'false';

    lastCard.setAttribute('data-product-id', productId);
    lastCard.setAttribute('data-product-title', productTitle);
    lastCard.setAttribute('data-product-handle', productHandle);
    lastCard.setAttribute('data-product-media', productMedia);
    lastCard.setAttribute('data-available', isAvailable.toString());
    
    if (isAvailable) {
      lastCard.classList.remove('sold-out');
    } else {
      lastCard.classList.add('sold-out');
    }
    
    const mediaScript = lastCard.querySelector('script[data-product-media]');
    if (mediaScript && drawerMediaData) {
      mediaScript.textContent = JSON.stringify(drawerMediaData);
    }
    
    const variantsScript = lastCard.querySelector('script[data-product-variants]');
    if (variantsScript && drawerVariants) {
      variantsScript.textContent = JSON.stringify(drawerVariants);
    }
    
    const image = lastCard.querySelector('.nail-selection__image');
    if (image && drawerMediaData && drawerMediaData[0]) {
      image.src = drawerMediaData[0].url.replace('width=600', 'width=300');
      image.alt = productTitle;
    }
    
    // Update card name
    const cardName = lastCard.querySelector('.nail-selection__card-name');
    if (cardName) {
      cardName.textContent = productTitle;
    }
    
    cards.forEach(card => {
      card.classList.remove('selected');
    });
    
    lastCard.classList.add('selected');
    
    this.updateShadeTitle(productTitle);
    
    // Update the Add to Cart button state
    if (mainComponent.updateAddToCartButtonState) {
      mainComponent.updateAddToCartButtonState();
    }
    
    requestAnimationFrame(() => {
      const selectedCard = mainComponent.querySelector('.nail-selection__card.selected');
      if (selectedCard) {
        const selectedProductMedia = selectedCard.getAttribute('data-product-media');
        const selectedProductId = selectedCard.getAttribute('data-product-id');
        
        // Now update the main product images using the main component's method
        if (mainComponent.updateMainProductImages) {
          mainComponent.updateMainProductImages(selectedProductMedia, selectedProductId);
        }
      }
    });
  }


  getProductVariants(card) {
    const scriptTag = card.querySelector('script[data-product-variants]');
    if (scriptTag) {
      try {
        return JSON.parse(scriptTag.textContent);
      } catch (e) {
        console.error('Error parsing product variants:', e);
        return [];
      }
    }
    return [];
  }

  addToCart(productId) {
    // Get product data from the selected card
    const selectedCard = this.querySelector('.nail-selection__card.selected');
    if (!selectedCard) return;

    const productTitle = selectedCard.getAttribute('data-product-title');
    const productMedia = selectedCard.getAttribute('data-product-media');
    const productHandle = selectedCard.getAttribute('data-product-handle');

    // Get product variants for the variant ID
    const variants = this.getProductVariants(selectedCard);
    const variantId = variants && variants.length > 0 ? variants[0].id : null;

    // Get prices from the new structure
    const memberPriceEl = selectedCard.querySelector('.nail-selection__price-main');
    const regularPriceEl = selectedCard.querySelector('.nail-selection__price-top');
    
    const memberPrice = memberPriceEl ? parseFloat(memberPriceEl.textContent.replace('$', '')) : 0;
    const regularPrice = regularPriceEl ? parseFloat(regularPriceEl.textContent.replace('$', '')) : 0;
    
    // Use appropriate price based on member mode
    const price = this.isMemberMode ? memberPrice : regularPrice;

    // Dispatch nail add event with global quantity
    const nailData = {
      productId: productId,
      variantId: variantId,
      title: productTitle,
      handle: productHandle,
      image: productMedia,
      price: price,
      memberPrice: memberPrice,
      regularPrice: regularPrice,
      quantity: this.globalQuantity,
      isMemberPrice: this.isMemberMode
    };

    const event = new CustomEvent('nail:add', {
      detail: nailData
    });
    document.dispatchEvent(event);
  }

  openDrawer() {
    const drawer = document.querySelector('nail-selection-drawer');
    if (drawer) {
      drawer.openDrawer();
    }
  }
}

customElements.define('nail-selection-component', NailSelectionComponent);

class NailSelectionDrawer extends NailSelectionComponent {
  constructor() {
    super();
    this.initDrawer();
  }

  initDrawer() {
    this.bindDrawerEvents();
    this.bindMemberToggleForDrawer();
    this.initDrawerMemberState();
  }

  initDrawerMemberState() {
    const savedState = sessionStorage.getItem('booClubWidgetSelected');
    this.isMemberMode = savedState !== '0';
    this.updateDrawerPrices();
  }

  bindMemberToggleForDrawer() {
    document.addEventListener('member:toggle', (event) => {
      this.isMemberMode = event.detail.isSelected;
      this.updateDrawerPrices();
    });
  }

  updateDrawerPrices() {
    const drawerContent = this.querySelector('.nail-selection__drawer');
    if (drawerContent) {
      drawerContent.dataset.memberMode = this.isMemberMode.toString();
    }
  }

  bindDrawerEvents() {
    const closeButtons = this.querySelectorAll('[data-drawer-close]');
    closeButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeDrawer();
      });
    });

    const overlay = this.querySelector('.nail-selection__drawer-overlay');
    if (overlay) {
      overlay.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeDrawer();
      });
    }

    this.bindDrawerCardClicks();

    this.bindDrawerInfoIconClicks();
  }

  bindDrawerInfoIconClicks() {
    const infoButtons = this.querySelectorAll('[data-member-info-trigger]');
    infoButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        
        this.closeDrawer();
        
        setTimeout(() => {
          this.showMemberPopup();
        }, 350);
      });
    });
  }

  showMemberPopup() {
    const dialog = document.querySelector('.exm_dialog-collection');
    if (dialog) {
      document.querySelector('.transition-body')?.classList.remove('transition-body');
      dialog.style.display = '';
      setTimeout(() => {
        dialog.classList.add('exm_clr-is-open');
      }, 10);
    }
  }

  bindDrawerCardClicks() {
    const drawerCards = this.querySelectorAll('.nail-selection__drawer-card:not(.sold-out)');
    drawerCards.forEach(card => {
      card.addEventListener('click', () => {
        const isAvailable = card.getAttribute('data-available') !== 'false';
        if (!isAvailable || card.classList.contains('sold-out')) {
          return;
        }
        
        const productId = card.getAttribute('data-product-id');
        const productTitle = card.getAttribute('data-product-title');
        const productHandle = card.getAttribute('data-product-handle');
        const productMedia = card.getAttribute('data-product-media');
        
        this.swapProduct(productId, productTitle, productHandle, productMedia, card);
        
        this.closeDrawer();
      });
    });
  }

  openDrawer() {
    const drawer = this.querySelector('.nail-selection__drawer');
    if (drawer) {
      drawer.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      
      requestAnimationFrame(() => {
        drawer.classList.add('active');
      });
    }
  }

  closeDrawer() {
    const drawer = this.querySelector('.nail-selection__drawer');
    if (drawer) {
      drawer.classList.remove('active');
      document.body.style.overflow = '';
      setTimeout(() => {
        drawer.style.display = 'none';
      }, 300);
    }
  }
}

customElements.define('nail-selection-drawer', NailSelectionDrawer);